import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { Box, TextField, Button, InputAdornment } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { initialValues, validationSchema } from 'forms/realEstateAgentRegistrationForm';

import useStyles from './useStyles';

const RealEstateAgentRegistrationForm = props => {
  const { t } = useTranslation();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const classes = useStyles();

  const { onSubmit } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  const handleClickShowPassword = () => setPasswordVisible(!isPasswordVisible);
  return (
    <Box className={classes.paper}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <TextField
          error={touched.firstName && Boolean(errors.firstName)}
          helperText={touched.firstName && t(errors.firstName)}
          variant="outlined"
          id="firstName"
          name="firstName"
          type="firstName"
          placeholder={t('components.RealEstateAgentRegistrationForm.firstName')}
          autoComplete="firstName"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstName}
          className={classes.field}
        />
        <TextField
          error={touched.lastName && Boolean(errors.lastName)}
          helperText={touched.lastName && t(errors.lastName)}
          variant="outlined"
          id="lastName"
          name="lastName"
          type="lastName"
          placeholder={t('components.RealEstateAgentRegistrationForm.lastName')}
          autoComplete="lastName"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastName}
          className={classes.field}
        />
        <TextField
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && t(errors.email)}
          variant="outlined"
          id="email"
          name="email"
          type="email"
          placeholder={t('components.RealEstateAgentRegistrationForm.email')}
          autoComplete="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          className={classes.field}
        />
        <TextField
          error={touched.mls && Boolean(errors.mls)}
          helperText={touched.mls && t(errors.mls)}
          variant="outlined"
          id="mls"
          name="mls"
          type="mls"
          placeholder={t('components.RealEstateAgentRegistrationForm.mls')}
          autoComplete="mls"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.mls}
          className={classes.field}
        />
        <TextField
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && t(errors.password)}
          variant="outlined"
          name="password"
          type={isPasswordVisible ? 'text' : 'password'}
          id="password"
          placeholder={t('components.RealEstateAgentRegistrationForm.password')}
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        <TextField
          error={touched.passwordConfirmation && Boolean(errors.passwordConfirmation)}
          helperText={(touched.passwordConfirmation && t(errors.passwordConfirmation)) || ' '}
          variant="outlined"
          name="passwordConfirmation"
          placeholder={t('components.RealEstateAgentRegistrationForm.confirmPassword')}
          type={isPasswordVisible ? 'text' : 'password'}
          id="passwordConfirmation"
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.passwordConfirmation}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.RealEstateAgentRegistrationForm.button')}
        </Button>
      </form>
    </Box>
  );
};

RealEstateAgentRegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default RealEstateAgentRegistrationForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/RealEstateAgentRegistrationForm/RealEstateAgentRegistrationForm.js